import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fullscreen-loader',
  templateUrl: './loader.component.html',
  imports: [CommonModule],
  styleUrls: ['./loader.component.scss']
})
export class FullscreenLoaderComponent {
  @Input() visible = false;
  @Input() message: string = 'Processing, Please Wait';
  @Input() bgColor?: string;
}
